import { ContainerCards, NestedUpContainer,  ASContainerCards, ASNestedUpContainer } from '../../utils/dndutils/containerformatters';
import { TopPanelNewClients, AddTicketDialog, AddGoodTicketDialog, EditNestedTableDialog, SwapBoxDialog, GenerateTableDialog, DealsInfoBox, ClientInfoBox, AddrInfoBox, GenerateTableDialogStorage } from '../../utils/dndutils/toppanelformatters';
import { CardItemAS, CardItemClient, CardItemGoods, CardItemShipment, CardNumber } from '../../utils/dndutils/cardformatters';

/*Это файл с дескрипторами для dnd меню. Выполняет роль конструктора.
Drag and drop имеет следующую структуру

./src
    ./api
        ./apiBridges 
            ./dndBridge.js  (Бриджи для дескриптора)
        ./descriptors
            ./addressableStorage.js (Дескрипторы)
    ./components
        ./DragDrop.js (Основной элемент drag end drop)
    ./utils
        ./dndutils
            ./cardformatters.js (Форматеры тикетов)
            ./containerformatters.js  (Форматеры контейнеров)
            ./staticresorces.js (Статические ресурсы)
            ./toppanelformaters.js  (Форматеры панелей фильтров)

Для создания нового элемента он размещается в соответствующем файле, после чего вкладывается в дескриптор, который работает как конструктор для данного меню
*/

export const AddressDs = {
    id: 'adrr_storage', //Имя дескриптора, по которому происходит вызов
    api: 'dndBridge', // Указание приджа для запросов
    title: 'Адресное хранение', //Имя страницы
    items: [  // Перечисление содержимого. Структура верхнего уровня фиксирована. 0 элемент отвечает за верхнее меню с фильтрами, 1 элемент отвечает за само dnd меню
      {id:'topPanel', title: 'Адресное хранение', formatter: TopPanelNewClients, items:[  // Элемент используемый для отображения верхнего меню
        {id: 'filter', params:{'time_filter':true, 'status_filter':true, 'data_filter':true}},  //Сожержимое компонента
        {id: 'data', title:'Информация', formatter: AddrInfoBox},
        {id:'newClientDialog', title:'Новая сделка', formatter:EditNestedTableDialog}
      ]},
      //Элемент отвечающий за dnd меню. Для переопределения поведения можно создавать компоненты-обёртки, как это происходит в данном дескрипторе
      {id:'dropZone', admin:true, formatter:ASNestedUpContainer, extendedBehavior:true, items: [  //Компонент переопределяющий поведение. Позволяет иметь воронки внутри воронки
        {id:'nestedDropZone', admin:true, nested:true, formatter:ASContainerCards, items: [ //Стандартный компонент dnd со стандартной логикой
            {id:'nestedGoods', expand:true, formatter:CardItemAS}  // Элемент карточки. Отвечает за отображение, поскольку логика перетаскивания описана в фиксированной обертке.
        ]}
      ]}],
    EIDS:'EIDeal',
    useTabs: true
  };
// Структура последующих дескрипторов анологична
  export const GoodsDs = {
    id: 'pik_goods',
    api: 'dndBridge',
    title: 'Забор товара',
    items: [
      {id:'topPanel', title: 'Забор товара', formatter: TopPanelNewClients, items:[
        {id: 'filter', params:{'time_filter':false, 'status_filter':true, 'data_filter':true}},
        {id: 'data.listItems', title:'Информация', formatter: DealsInfoBox},
        {id:'newClientDialog', title:'Таблица сделок', formatter:GenerateTableDialog}
      ]},
      {id:'dropZone', admin:true, formatter:ContainerCards, extendedBehavior:true, items: [
          {id:'goods', expand:false, formatter:CardItemGoods}
    ]}],
    EIDS:'EIDeal'
  };

  export const MovingDealsDs = {
    id: 'moving_deals',
    api: 'dndBridge',
    title: 'Движение товара',
    items: [
      {id:'topPanel', title: 'Движение товара', formatter: TopPanelNewClients, items:[
        {id: 'filter', params:{'time_filter':false, 'status_filter':true, 'data_filter':true}},
        {id: 'data.listItems', title:'Информация', formatter: DealsInfoBox},
        {id:'newClientDialog', title:'Таблица сделок', formatter:GenerateTableDialog}
      ]},
      {id:'dropZone', admin:true, formatter:ContainerCards, extendedBehavior:true, items: [
          {id:'goods', expand:false, formatter:CardItemGoods}
    ]}],
    EIDS:'EIDeal'
  };

  export const ProductsStorageDs = {
    id: 'products_storage',
    api: 'dndBridge',
    title: 'Хранение товара',
    items: [
      {id:'topPanel', title: 'Хранение товара', formatter: TopPanelNewClients, items:[
        {id: 'filter', params:{'time_filter':false, 'status_filter':true, 'data_filter':true}},
        {id: 'data.listItems', title:'Информация', formatter: DealsInfoBox},
        // {id:'productSwapDialog', title:'Переместить товар', formatter:SwapBoxDialog},
        {id:'newClientDialog', title:'Таблица сделок', formatter:GenerateTableDialogStorage}
      ]},
      {id:'dropZone', admin:true, formatter:ContainerCards, extendedBehavior:true, items: [
          {id:'goods', expand:false, formatter:CardItemGoods}
    ]}],
    EIDS:'EIDeal'
  };

  export const ProductsShipmentDs = {
    id: 'products_shipment',
    api: 'dndBridge',
    title: 'Отгрузка',
    items: [
      {id:'topPanel', title: 'Хранение товара', formatter: TopPanelNewClients, items:[
        {id: 'filter', params:{'time_filter':false, 'status_filter':true, 'data_filter':true}},
        {id: 'data.listItems', title:'Информация', formatter: DealsInfoBox},
        {id:'newClientDialog', title:'Таблица сделок', formatter:GenerateTableDialog}
      ]},
      {id:'dropZone', admin:true, formatter:ContainerCards, extendedBehavior:true, items: [
          {id:'goods', expand:false, formatter:CardItemShipment}
    ]}],
    EIDS:'EIDeal'
  };

  export const NewClientsDs = {
    id: 'new_clients',
    api: 'dndBridge',
    title: 'Новые клиенты',
    items: [
        {id:'topPanel', title: 'Новые клиенты', formatter: TopPanelNewClients, items:[
          {id: 'filter', params:{'time_filter':true, 'status_filter':false}},
          // {id:'newClientDialog', title:'Новый клиент', formatter:AddTicketDialog}
        ]},
        {id:'dropZone', admin:true, formatter:ContainerCards, extendedBehavior:true, items: [
            {id:'newClient', formatter: CardNumber}
    ]}],
  };


    export const MyClientsDs = {
    id: 'my_clients',
    api: 'dndBridge',
    title: 'Мои клиенты',
    items: [
        {id:'topPanel', title: 'Мои клиенты', formatter: TopPanelNewClients, items:[
          {id: 'filter', params:{'status_filter':false}},
          {id:'data.listItems', title:'Информация', formatter: ClientInfoBox},
          {id:'newClientDialog', title:'Новый клиент', formatter:AddTicketDialog}
        ]},
        {id:'dropZone', admin:false, formatter:ContainerCards, extendedBehavior:true, items: [
            {id:'newClient', formatter: CardItemClient}
        ]}
    ],
    EIDS: "CliInfo"
  };
